package com.playoffpulse.frontend.data

import com.playoffpulse.shared.model.LeagueId
import com.playoffpulse.shared.model.BestCaseClinchResponse
import com.playoffpulse.shared.model.BlockedShotsChartBundleResponse
import com.playoffpulse.shared.model.BlockedShotsMissesMode
import com.playoffpulse.shared.model.BlockedShotsChartResponse
import com.playoffpulse.shared.model.BlockedShotsTeamDetailResponse
import com.playoffpulse.shared.model.DraftWatchResponse
import com.playoffpulse.shared.model.ImportantGamesResponse
import com.playoffpulse.shared.model.ImportantGamesObjective
import com.playoffpulse.shared.model.ImportantGamesWindow
import com.playoffpulse.shared.model.MagicSummary
import com.playoffpulse.shared.model.StandingsInsightsResponse
import com.playoffpulse.shared.model.StandingsSnapshot
import com.playoffpulse.shared.model.TeamRef
import com.playoffpulse.shared.model.TopRivalsResponse
import com.playoffpulse.shared.model.VanquishedResponse
import com.playoffpulse.shared.model.YesterdayMovementResponse

interface PlayoffDataProvider {
    suspend fun getTeams(league: LeagueId = LeagueId.NHL): List<TeamRef>

    suspend fun getStandings(league: LeagueId = LeagueId.NHL): StandingsSnapshot

    suspend fun getStandingsInsights(league: LeagueId = LeagueId.NHL): StandingsInsightsResponse

    suspend fun getBlockedShotsChart(
        league: LeagueId = LeagueId.NHL,
        missesMode: BlockedShotsMissesMode = BlockedShotsMissesMode.INCLUDE,
    ): BlockedShotsChartResponse

    suspend fun getBlockedShotsChartBundle(
        league: LeagueId = LeagueId.NHL,
        missesMode: BlockedShotsMissesMode = BlockedShotsMissesMode.INCLUDE,
    ): BlockedShotsChartBundleResponse

    suspend fun getBlockedShotsTeamDetail(
        teamId: String,
        league: LeagueId = LeagueId.NHL,
        missesMode: BlockedShotsMissesMode = BlockedShotsMissesMode.INCLUDE,
    ): BlockedShotsTeamDetailResponse

    suspend fun getMagicSummary(teamId: String, league: LeagueId = LeagueId.NHL): MagicSummary

    suspend fun getImportantGames(
        teamId: String,
        window: ImportantGamesWindow,
        objective: ImportantGamesObjective = ImportantGamesObjective.PLAYOFF,
        league: LeagueId = LeagueId.NHL,
    ): ImportantGamesResponse

    suspend fun getTopRivals(
        teamId: String,
        league: LeagueId = LeagueId.NHL,
    ): TopRivalsResponse

    suspend fun getBestCaseClinch(
        teamId: String,
        league: LeagueId = LeagueId.NHL,
    ): BestCaseClinchResponse

    suspend fun getVanquished(
        teamId: String,
        league: LeagueId = LeagueId.NHL,
    ): VanquishedResponse

    suspend fun getDraftWatch(
        teamId: String,
        league: LeagueId = LeagueId.NHL,
    ): DraftWatchResponse

    suspend fun getYesterdayMovement(league: LeagueId = LeagueId.NHL): YesterdayMovementResponse
}

class ProviderException(message: String, cause: Throwable? = null) : RuntimeException(message, cause)
